export default "__VITE_ASSET__CGktD_LO__"